<script lang="ts">
	import type { Component, HTML } from '@prisma/client';
	import FormGroup from '../sub_components/FormGroup.svelte';

	export let Config: HTML & Component;
	export function validate() {
		return true;
	}
	export function appendData(formData: FormData) {
		return true;
	}
	export function show() { // Display HTML
		Config.Shown = true;
	}
	export function hide() { // Hide HTML
		Config.Shown = false;
	}
</script>

<FormGroup {Config}>
	<div class="col">
		<!-- <p class="fs-7 lh-1">
			1. Please note that you are only permitted to sell the Products online through a Permissible
			Public Website as defined in our Reseller (Dealer?) Policy, which is a website that:<br />
			(i) is operated by you in your own legal or registered fictitious name,<br />
			(ii) clearly states your legal name or registered fictitious name and contact information,<br
			/>
			(iii) does not give the appearance that it is operated by King Technology or any third party,<br
			/>
			(iv) has been disclosed to King Technology through this form, and<br />
			(v) is operated in compliance with the
			<a href="http://www.kingauthorizedseller.com/"
				>King Technology, Inc. Online Sales Guidelines</a
			><br />
		</p>
		<p class="fs-6 lh-1">
			<strong
				>Consent to sell the Products on online marketplaces is not granted through this form.</strong
			>
		</p>
		<p class="fs-7 lh-1">
			King Technology reserves the right to terminate, at any time and in its sole discretion, its
			approval for you to market and sell any or all of our Products on any or all Permissible
			Public Website(s) disclosed through this form.
		</p> -->

		{@html Config.Value}
	</div>
</FormGroup>
